<template>
    <div class="subject">
        <subject-skeleton v-if="loading" style="margin-top: 30px;margin-bottom: 200vh"></subject-skeleton>
        <div>
            <div class="bg" v-if="topic.main_type == 1" :style="'background-image: url('+topic.main_cover_img+')'">
                <div class="home-header" v-if="topic.search_show_type == 1">
                    <van-search shape="round" class="header-search" left-icon="/static/bytx/public/search_black.svg" @click="search" v-model="value" placeholder="肺癌早期预防"/>
                </div>
            </div>
            <video v-if="topic.main_type == 2" id="my-video" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="none" x5-playsinline="" webkit-playsinline="" playsinline="" :poster="topic.cover_img" x-webkit-airplay="true"></video>

            <div class="section1" v-if="topic.intro != '' || message.length > 0">
                <div class="bots">
                    <div class="introduce" v-if="topic.intro != ''">
                        <p :class="[textToggle ? '' : 'active']" v-html="topic.intro"></p>
                        <div v-if="textToggle" class="toggle">
                            <span @click="textToggle = false">
                                <span>展开</span>
                                <img src="/static/bytx/subject/more_down.svg" alt="">
                            </span>
                        </div>
                        <div v-else class="toggle">
                            <span @click="textToggle = true">
                                <span>收起</span>
                                <img src="/static/bytx/subject/more_up.svg" alt="">
                            </span>
                        </div>
                    </div>
                    <!--消息滚动栏 -->
                    <div class="msg" v-if="message.length > 0">
                        <div class="msg-left">
                            <img src="/static/bytx/subject/msg.svg">
                        </div>
                        <div class="msg-right">
                            <van-swipe style="height: 50px;" vertical :autoplay="3000" :show-indicators="false">
                                <van-swipe-item v-for="(item, index) in message" :key="index" @click="goMsg(item)">
                                    <div class="item">
                                        <div class="desc">
                                            <p>{{ item.title }}</p>
                                        </div>
                                        <div class="right" v-if="item.link != ''">
                                            <img src="/static/bytx/subject/msg_more.svg" alt="">
                                        </div>
                                    </div>
                                </van-swipe-item>
                            </van-swipe>
                        </div>
                    </div>

                </div>
            </div>

            <div class="topic-section" v-for="val in topic.topics">
                <div class="swipe" v-if="val.key == 'banner' && val.content != null && val.content.length > 0" >
                    <van-swipe :autoplay="3000" indicator-color="#fff" v-if="val.content != null && val.content.length > 0">
                        <van-swipe-item v-for="(item, i) in val.content" :key="i" @click="goBanner(item)">
                            <a @click.prevent="toLink(item.target_url,item)">
                            <!-- <a :href="item.target_url.replace('https://bytx.care-gobroad.com','')"> -->
                                <img :src="item.img" alt="" />
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>


                <!--专栏样式1 -->
                <div class="science" v-if="val.key == 'column_1' && val.content != null && val.content.length > 0" >
                    <div class="title">
                        <img :src="val.logo" alt="">
                        <span>{{val.title}}</span>
                    </div>
                    <div class="science-box">
                        <div class="science-box-wrap" v-for="(item,index) in val.content" :key="index" @click="goDetail(item)">
                            <div v-if="index == 0" class="science-box-wrap-first">
                                <img :src="item.cover_img" alt="">
                                <div class="science-box-wrap-first-bot">
                                    <div> {{ item.title }}</div>
                                    <div>
                                        <span class="desc">{{ item.desc }}</span>
                                        <img v-if="item.origin_type == 8" class="apply" src="/static/bytx/welfare_sqjz_btn.svg" alt="" @click.stop="goDetail(item)">
                                    </div>
                                </div>
                                <div class="science-box-wrap-first-icon">
                                    <div class="column-origin-type">
                                        {{originTypes[item.origin_type]}}{{item.origin_type < 5 && item.type == 2 ? "专栏" : ''}}
                                    </div>
                                </div>
                            </div>
                            <div v-else class="science-box-wrap-other">
                                <img :src="item.cover_img" alt="">
                                <div class="science-box-wrap-other-bot">
                                    <div> {{ item.title.length > 18 ? item.title.substring(0,18)+"..." : item.title }}</div>
                                    <div>
                                    <span class="desc">
                                        {{ item.origin_type == 4 && item.type != 2 ? item.start_at_format : item.view_count + "人观看" }}
                                    </span>
                                    </div>
                                </div>
                                <div class="science-box-wrap-other-icon">
                                    <div :class="'column-origin-type '+originTypeEn[item.origin_type]">
                                        {{originTypes[item.origin_type]}}{{item.type == 2 ? "专栏" : ''}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--肿瘤专栏 -->
                <div class="special1" v-if="val.key == 'column_2' && val.content != null && val.content.length > 0">
                    <div class="title">
                        <img :src="val.logo" alt="">
                        <span>{{ val.title }}</span>
                    </div>
                    <div class="special1-box" v-for="(item, index) in val.content" :key="index" @click="goDetail(item)">
                        <div v-if="index == 0" class="special1-box-first">
                            <img :src="item.cover_img" alt="">
                            <div class="special1-box-first-bot">
                                <div> {{ item.title }}</div>
                                <div>
                                    <span class="desc">{{ item.desc }}</span>
                                    <!--                                <img class="apply" src="/static/bytx/welfare_sqjz_btn.svg" alt="" @click.stop="applyHelp(item)">-->
                                </div>
                            </div>
                            <div class="special1-box-first-icon">
                                <div :class="'column-origin-type '+originTypeEn[item.origin_type]">
                                    {{originTypes[item.origin_type]}}{{item.type == 2 ? "专栏" : ''}}
                                </div>
                            </div>
                        </div>
                        <div v-else class="special1-box-other">
                            <div class="special1-box-other-img">
                                <img :src="item.cover_img" alt="">
                            </div>
                            <div class="special1-box-other-text">
                                <div class="special1-box-other-text-top">
                                    <div>{{ item.title.length > 18 ? item.title.substring(0,18)+"..." : item.title }}</div>
                                </div>
                                <div class="special1-box-other-text-bot">
                                    <span>{{ item.origin_type == 4 && item.type != 2 ? item.start_at_format : item.view_count + "人观看" }}</span>
                                    <!--                                <span>已预约</span>-->
                                </div>
                            </div>
                            <div class="special1-box-other-icon">
                                <div :class="'column-origin-type '+originTypeEn[item.origin_type]">
                                    {{originTypes[item.origin_type]}}{{item.type == 2 ? "专栏" : ''}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!--肿瘤专栏 -->
                <div class="special2" v-if="val.key == 'column_3' && val.content != null && val.content.length > 0">
                    <div class="title">
                        <img :src="val.logo" alt="">
                        <span>{{val.title}}</span>
                    </div>
                    <div class="special2-box">
                        <div class="special2-box-wrap" v-for="(item,index) in val.content" :key="index" @click="goDetail(item)">
                            <img :src="item.cover_img" alt="">
                            <div class="special2-box-wrap-bot">
                                <div> {{ item.title }}</div>
                                <div>
                                    <span class="desc">{{ item.time }}</span>
                                    <img  v-if="item.origin_type == 8" class="apply" src="/static/bytx/welfare_sqjz_btn.svg" alt="" @click.stop="goDetail(item)">
                                </div>
                            </div>
                            <div class="special2-box-wrap-icon">
                                <!--                            <img src="/static/bytx/public/tag_live_best_icon.svg" alt="">-->
                                <div :class="'column-origin-type '+originTypeEn[item.origin_type]">
                                    {{originTypes[item.origin_type]}}{{item.type == 2 ? "专栏" : ''}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- 肿瘤手册-->
                <div class="manual" v-if="val.key == 'column_4' && val.content != null && val.content.length > 0">
                    <div class="title">
                        <img :src="val.logo" alt="">
                        <span>{{ val.title }}</span>
                    </div>
                    <div class="manual-content">
                        <div v-for="(item,index) in val.content" :key="index" @click="goLink(item.link,item)" class="manual-content-item" :class="[index > 2 ? 'active' : '']">
                            <img :src=item.logo alt="">
                            <span>{{ item.title }}</span>
                        </div>
                    </div>
                </div>

                <!--专家介绍 -->
                <div class="expert" v-if="val.key == 'professor_left' && val.content != null && val.content.length > 0">
                    <div class="title">
                        <img :src="val.logo" alt="">
                        <span>{{ val.title }}</span>
                    </div>
                    <div class="expert-content">
                        <div class="expert-content-center">
                            <div class="expert-content-center-item" v-for="(item,index) in val.content" :key="index" @click="goProfessor(item,val.id,index)">
                                <div class="expert-content-center-item-wrap">
                                    <img :src="item.professor.avatar" alt="">
                                    <div>{{ item.title.length > 5 ? item.title.substring(0,5)+"..." : item.title }}</div>
                                    <div>{{ item.professor.position }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--专家介绍 -->
                <div class="expert" v-if="val.key == 'professor' && val.content != null && val.content.length > 0">
                    <div class="title">
                        <img :src="val.logo" alt="">
                        <span>{{ val.title }}</span>
                    </div>
                    <div class="expert-content-main">
                        <div class="expert-content-main-section">
                            <img :src="item.cover_img" style="width: 100%;margin-bottom: 15px" alt="" v-for="(item,index) in val.content" :key="index" @click="goProfessor(item,val.id,index)">
                        </div>
                    </div>
                </div>

                <!-- 合作方-->
                <div class="partner" v-if="val.key == 'media' && val.content != null && val.content.length > 0">
                    <div class="title">
                        <img :src="val.logo" alt="">
                        <span>{{ val.title }}</span>
                    </div>

                    <div class="partner-content">
<!--                        <div class="media_slide" v-for="(item, index) in val.content" :key="index">-->
<!--                            <img :src="item.logo" alt="">-->
<!--                        </div>-->
                      <van-swipe class="partner-content-swipe" >
                        <van-swipe-item v-for="(item, ind) in val.content" :key="ind">
                          <div class="media_slide" v-for="(item, index) in item" :key="index">
                             <img :src="item.logo" alt="">
                          </div>
                        </van-swipe-item>
                      </van-swipe>
                    </div>
                </div>

            </div>

            <div class="bot">
                {{ this.topic.footer_content }}
            </div>
            <!--悬浮窗 -->
            <a v-if="cover_icon.length > 0 && item.title != '分享'"
               href="javascript:void (0)"
               v-for="(item, index) in cover_icon"
               :key="index" :class="`btn${index+1}`"
               @click="goCoverIcon(item)">
                <img class="course-detail-home-button" :src="item.img" alt="">
            </a>
            <a v-if="cover_icon.length > 0 && item.title == '分享'"
               href="javascript:void (0)"
               v-for="(item, index) in cover_icon"
               :key="index"
               class="topic-share-icon"
               @click="goCoverIcon(item)">
                <img class="course-detail-home-button" :src="item.img" alt="">
            </a>

            <van-overlay :show="showShareDialog" @click="showShareDialog = false">
                <div class="share-box">
                    <div class="block">
                        请点击 “...”，再点击发送给朋友 | <span>知道啦</span>
                    </div>
                    <div class="share-box-bottom">
                        <img src="/static/bytx/detail_forward_2_img.png" alt="">
                    </div>
                </div>
            </van-overlay>
        </div>
    </div>
</template>

<script>
import subjectSkeleton from "../../skeleton/subjectSkeleton";
import Interface from "../../util/interface";
import videojs from "video.js";
import {LocationHref,toMiniProgramPage} from '@/util/common'

export default {
    name: "index",
    components: {
        subjectSkeleton
    },
    data() {
        return {
            id:0,
            topic: {},
            loading: true,
            message:[],
            column_2:null,
            column_3:null,
            column_4:null,
            professor:null,
            professor_left:null,
            media:null,
            cover_icon:[],
            showShareDialog:false,
            originTypes:{
                2:"图文",
                3:"视频",
                4:"直播",
                7:"临床招募",
                8:"公益救助",
                13:"音频",
                16:"专题",
                17:""
            },
            originTypeEn:{
                2:"article",
                3:"video",
                4:"live",
                7:"recruit",
                8:"help",
                13:"audio",
                16:"topic",
                17:"link"
            },

            value: '',
            messageArr: [{message: '博医同行“肿瘤防治周”每周日晚上19:00准时和大家见面', duration_str: '5秒前'}],
            iconList: [],  // 悬浮框
            textToggle: true,
            myPlayer:"",
            record_id: 0, // 打点接口返回数据
            timer: null
        }
    },
    methods: {
        toLink(url,item){
            if(item.title ==='儿血探微'){
                window.location.href = url;
            }if(item.title ==='不懂就问'){
                window.location.href = url;
            }else{
                const links1 = url.replace('https://bytx.care-gobroad.com', '')
                const links = links1.replace('https://care-yyh.com', '')
                LocationHref(links)
            }
           
        },
        // 点击搜索
        search() {
            this.$router.push({name:'search',query:{form:"community"}})
        },
        // 获取icon列表
        getIconList() {
            Interface.getData('get', Interface.public.icon).then((res) => {
                if (res.code == 0) {
                    this.iconList = res.data
                }
            })
        },
        fetch(scene){
            if (scene === 'homepage') {
                Interface.getData('get', Interface.subject.index+this.id).then(res => {
                    if (res.code == 0) {
                        this.topic = res.data

                        if(this.topic.main_type == 2){
                            Interface.getData('get', Interface.video_info + '/' + res.data.main_video_id).then((resp) => {
                                let videoUrl;
                                resp.data.PlayInfoList.PlayInfo.forEach((val)=>{
                                    if(val.Format == 'mp4'){
                                        videoUrl = val.PlayURL
                                    }
                                })
                                const myPlayerOptions = {
                                    bigPlayButton: true,
                                    textTrackDisplay: true,
                                    posterImage: true,
                                    errorDisplay: true,
                                    controlBar: true,
                                    autoplay:false,
                                    controls: true,
                                }
                                this.course_img_visible = false
                                setTimeout(() => {
                                    this.myPlayer = videojs('my-video', myPlayerOptions,function onPlayerReady(){})
                                    this.myPlayer.src(videoUrl)
                                    this.myPlayer.load(videoUrl)
                                    setTimeout(()=>{
                                        this.loading = false
                                    },500)
                                }, 500)
                            },300)
                        }else{
                            this.loading = false
                        }

                        let wechat_logo = this.topic.cover_img
                        if(this.topic.wechat_logo){
                            wechat_logo = this.topic.wechat_logo
                        }

                        let wechat_desc = this.topic.desc
                        if (wechat_desc){
                            wechat_desc = this.topic.wechat_desc
                        }

                      Interface.getData('post',Interface.footprint, {
                        id: this.id,
                        type: 16,
                        content_type: 0,
                        page_type: 5,
                        source_type: 0,
                        parent_id: this.id,
                        record_id: 0,
                        title: this.topic.title
                      }).then((res) => {
                        if (res.code == 0) {
                          this.record_id = res.data.record_id
                        }
                      })
                        Interface.getShareInfo(this, this.topic.title+"-博医同行", wechat_logo, wechat_desc)
                        let obj = [{ origin_id: Number(this.id), type: 16, title: this.topic.title, page_type: 5}]
                        // Interface.exposureFootPrint(JSON.stringify(obj))
                        this.topic.topics.forEach(val => {
                            if ('message' === val.key && val.content) {
                                this.message = val.content
                            }else if('column_2' === val.key && val.content) {
                                this.column_2 = val
                            }else if('column_3' === val.key && val.content) {
                                this.column_3 = val
                            }else if('column_4' === val.key && val.content) {
                                this.column_4 = val
                            }else if('professor' === val.key && val.content) {
                                this.professor = val
                            }else if('professor_left' === val.key && val.content) {
                                this.professor_left = val
                            }else if('media' === val.key && val.content) {
                                let arr = []
                                let tempArr = val.content
                                for(let i=0;i<tempArr.length;i+=6){
                                  arr.push(tempArr.slice(i,i+6));
                                }
                                val.content = arr
                            }else if('cover_icon' === val.key && val.content) {
                                this.cover_icon = val.content
                            }
                        })

                    }
                })
            }
        },
        goLink(link,item){
            if(item.title ==='儿血探微'){
                window.location.href = link;
            }if(item.title ==='不懂就问'){
                toMiniProgramPage(link,'redirectTo','/pkg/home/manual/index/index')
            }else{
                if (link != "") {
                    Interface.goLink(link)
                }
            }
            // if (id) {
            //   // Interface.footPrint1('64', id)
            // }
          Interface.mFootPrint(item.id, 105,0, 5, 0, this.id,0, item.title)
        },
        goMsg(item) {
          if (item.link != "") {
            Interface.goLink(item.link)
          }
          if (item.id) {
            Interface.mFootPrint(item.id, 64,0, 5, 0, this.id,0,item.title)
          }
        },
        goBanner(item) {
          Interface.goLink(item.target_url)
          Interface.mFootPrint(item.id, 62,0, 5, 0, this.id,0,item.title)
        },
        goCoverIcon(item){
            if (item.link != "") {
                Interface.goLink(item.link)
            }else if(item.title == '分享'){
                //showShare()
                this.showShareDialog = true
            }
            // Interface.footPrint1('50', item.id)
          Interface.mFootPrint(item.id, 50,0, 5, 0, this.id,0,item.title)
        },
        goProfessor(item,topic_id,index){

            if(item.content_type == 1){
                Interface.goProfessor(this,item.professor.id)
                // Interface.footPrint1('65',item.id)
                Interface.mFootPrint(item.id, 65,0, 5, 0, this.id,0,item.title)
            }else{
                let params = {
                    id:this.$route.params.id,
                    topic:topic_id,
                    i:index,
                }
                this.$router.push({name:'topic-article',params:params})
                // Interface.footPrint1('65',item.id)

            }
        },
        goDetail(item){

            //2图文，3视频，4直播，7临床招募，8公益救助，13音频，16专题，17专题跳转链接
            switch (item.origin_type){
                case 2:
                    Interface.goArticle(this,item.origin_id,item.type);
                    break
                case 3:
                    Interface.goVideo(this,item.origin_id,item.type);
                    break
                case 4:
                    Interface.goLive(this,item.origin_id,item.type,item.live_status);
                    break
                case 7:
                    Interface.goClinic(this,item.origin_id,item.type);
                    break
                case 8:
                    Interface.goMedicalAssistance(this,item.origin_id,item.type);
                    break
                case 13:
                    Interface.goAudio(this,item.origin_id,item.type);
                    break
                case 16:
                    Interface.goTopic(this,item.origin_id);
                    break
                case 17:
                    Interface.goLink(item.link);
                    break
            }
          Interface.mFootPrint(item.id, 106,0, 5, 0, this.id,0, item.title)
        }
    },
    watch:{
        async $route(to,from){
            window.location.reload()
        }
    },
    created() {
        this.id = this.$route.params.id
        this.fetch("homepage")
        this.timer = setInterval(() => {
          if (this.record_id) {
            Interface.mFootPrint(this.id, 16,0, 5, 0, this.id,this.record_id,this.topic.title)
          }
        }, 6000)
    },
    destroyed() {
        if(this.myPlayer){
            this.myPlayer.dispose()
        }
    },
    beforeRouteLeave(to, from, next) {
      if (this.record_id) {
        Interface.mFootPrint(this.id, 16,0, 5, 0, this.id,this.record_id,this.topic.title)
      }
      clearInterval(this.timer)
      next()
    }
}
</script>

<style scoped lang="scss">
@import "./index.scss";


</style>



// WEBPACK FOOTER //
// src/views/subject/index.vue